<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M0 0h24v24H0z" fill="none" />
        <path
            d="M5 20h14v-2H5v2zm14-7h-4v5H9v-5H5l7-7 7 7z"
            fill="currentColor"
        />
    </svg>
</template>
